import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { VideoProcessTO } from "../model/video-process.model";

@Injectable({
    providedIn: "root"
})
export class VideoProcessService {
    private videoProcessSubject: BehaviorSubject<{ [key: string]: VideoProcessTO }>;

    constructor(private http: HttpClient) {
        this.videoProcessSubject = new BehaviorSubject<{ [key: string]: VideoProcessTO }>({});
    }

    public videoProcessAsync = (): Observable<{ [key: string]: VideoProcessTO }> =>
        this.videoProcessSubject.asObservable();

    public getVideoProcess(jobId: string): void {
        this.http
            .get<VideoProcessTO>(`${environment.streaming.url}/api/v1/convert/${jobId}`)
            .subscribe((response) => {
                if (response) {
                    const dict = this.videoProcessSubject.getValue();

                    dict[jobId] = response;

                    this.videoProcessSubject.next(dict);
                }
            });
    }
}
